import { Grid } from "@mui/material";
import { IMultiImage } from "./IMultiImage";
import { useEffect, useState } from "react";
import FullScreenMultiImage from "./fullScreenMultiImage";
import './multiImage.css'

export default function MultiImage({ data, title, setUserMultiImage }: IMultiImage) {

    //add ! =>setUserMultiImage!(data)

    return (
        <>
            <div style={{ paddingBottom: "40px", width: "50%", paddingLeft: "10px" }} onClick={() => setUserMultiImage!(data)}>

                <Grid container  >
                    {new Array(4).fill(0).map((_, index: any) => {
                        return <Grid item xs={6} spacing={1} style={{ paddingBottom: "5px", paddingLeft: "5px" }}>
                            {(data != null && data.length >= (index + 1)) ?
                                data.length > 4 && index == 3 ?
                                    <div className="image-container">
                                        <img src={data[index]?.fileUrl} alt="overlay" className="grayImage" />
                                        <div className="overlay"></div>
                                        <span className="overlay-number">{data.length - 4}   +</span>
                                    </div>
                                    :
                                    <img
                                        src={data[index]?.fileUrl}
                                        className="text-center block m-auto"
                                        style={{ height: "80px", width: "100%" }}

                                    />
                                :
                                <div

                                    style={{ height: "80px", width: "100%", backgroundColor: "#E6E9F4" }}
                                />}

                        </Grid>
                    })}

                </Grid >
                <span style={{ fontSize: "12px", fontWeight: "bold", color: "var(--primary-text-color)" }}>{title}</span>
            </div>


        </>

    )
}